import { ADDRESS_ZERO } from '@uniswap/router-sdk';

export const ELEVATE_MAINNET_TOKENS = {
  ETH: ADDRESS_ZERO,
  GREEN: '0xb2089a7069861c8d90c8da3aacab8e9188c0c531',
  IZE: '0xf7e945FcE8F19302AaCc7E1418b0A0bdef89327B',
  SWITCH: '0xb10cc888cB2CcE7036F4c7ECAd8a57Da16161338',
  WIN: '0xb10CB07CA2CDac77FbB5707f6690301f9d036F45',
  ELEMENT: '0x600d601d8b9eb5de5ac90fefc68d0d08801bfd3f',
  ELEVATE: '0x888888888887715FB9D9F84175Af9e6cCE46807e',
  RALLY: '0x19640000000ba88d36206BeB10D0e86011C8d08c',
  GROW: '0x1223334444A7466fBf985B14E1F4EdAf3883bCa6',
  GULD: '0x14d6c649292c5c9790c5196d1a9ea039307947a1',
};

export const ALLOWED_TO_TOKENS_FOR_ELEVATE_SWAP = [
  ELEVATE_MAINNET_TOKENS.GREEN,
  ELEVATE_MAINNET_TOKENS.IZE,
  ELEVATE_MAINNET_TOKENS.SWITCH,
  ELEVATE_MAINNET_TOKENS.WIN,
  ELEVATE_MAINNET_TOKENS.ELEMENT,
  ELEVATE_MAINNET_TOKENS.ELEVATE,
  ELEVATE_MAINNET_TOKENS.RALLY,
  ELEVATE_MAINNET_TOKENS.GROW,
  ELEVATE_MAINNET_TOKENS.GULD,
];

export const ELEVATE_SWAP_EXACT_INPUT_SINGLE_TOKENS = [ELEVATE_MAINNET_TOKENS.ELEVATE];
